import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { NFeStatus } from '../../../types/nfe';
import { toDateInputValue } from '../../../utils/dateUtils';

interface NFeFiltrosProps {
  status?: NFeStatus;
  dataInicio?: string;
  dataFim?: string;
  onStatusChange: (status?: NFeStatus) => void;
  onDataInicioChange: (data?: string) => void;
  onDataFimChange: (data?: string) => void;
}

const NFeFiltros: React.FC<NFeFiltrosProps> = ({
  status,
  dataInicio,
  dataFim,
  onStatusChange,
  onDataInicioChange,
  onDataFimChange,
}) => {
  return (
    <Row className="mb-3 g-2">
      <Col xs={12} md={4}>
        <Form.Group>
          <Form.Label className="text-body-secondary small mb-1">Status</Form.Label>
          <Form.Select
            value={status ?? ''}
            onChange={(e) => {
              const val = e.target.value;
              onStatusChange(val ? val as NFeStatus : undefined);
            }}
            className="form-select-sm"
          >
            <option value="">Todos</option>
            <option value={NFeStatus.Rascunho}>Rascunho</option>
            <option value={NFeStatus.Completa}>Completa</option>
          </Form.Select>
        </Form.Group>
      </Col>

      <Col xs={12} md={4}>
        <Form.Group>
          <Form.Label className="text-body-secondary small mb-1">Data Início</Form.Label>
          <Form.Control
            type="date"
            value={dataInicio ? toDateInputValue(dataInicio) : ''}
            onChange={(e) => {
              const val = e.target.value;
              onDataInicioChange(val ? new Date(val).toISOString() : undefined);
            }}
            className="form-control-sm"
          />
        </Form.Group>
      </Col>

      <Col xs={12} md={4}>
        <Form.Group>
          <Form.Label className="text-body-secondary small mb-1">Data Fim</Form.Label>
          <Form.Control
            type="date"
            value={dataFim ? toDateInputValue(dataFim) : ''}
            onChange={(e) => {
              const val = e.target.value;
              onDataFimChange(val ? new Date(val).toISOString() : undefined);
            }}
            className="form-control-sm"
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default NFeFiltros;
